import { createContext } from "react";

const AuthContext = createContext(null);

export default AuthContext;